export default "__VITE_ASSET__CYRsfdRh__"